import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Backdrop, Box, CircularProgress, Container, Grid } from '../../components/mui/Core/index'
import GenericNav from '../../components/genericcomponents/navbars/GenericNav'
import ItemTagDetailsCard from './components/ItemTagDetailsCard/item-tag-details-card'
import SerialNumbersTable from './components/SerialNumbersTable/serial-numbers-table'
import OrderItemDetailsCard from './components/OrderItemDetailsCard/order-item-details-card'
import useBrowserTabTitles from '../../hooks/browserTabTitles/browser-tab-titles'
import { fetchSerialNumbers } from './serial-numbers-slice'
import GenericSnackbar from '../../components/GenericSnackbar/generic-snackbar'
import { parentFeatureConstants } from '../../constants/parent-feature-constants'
import { setSnackbar } from '../../components/GenericSnackbar/generic-snackbar-slice'
import PageTitle from '../../components/PageTitle/page-title'
import Constants from '../../constants/en.json'
import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'

function SerialNumbers() {
  const dispatch = useDispatch()
  const parentFeature = useSelector((state) => state.serialNumbers.parentFeature)
  const authenticatedUser = useSelector((state) => state.login.authenticatedUser)
  const selectedClient = JSON.parse(
    sessionStorage.getItem(sessionStorageKeyConstants.SELECTED_CLIENT),
  )
  const dmsUser = selectedClient?.dmsFlag || authenticatedUser?.dms
  const selectedItemTag = useSelector((state) => state.serialNumbers.selectedItemTag)
  const selectedOrder = useSelector((state) => state.order.selectedOrder)
  const selectedShipment = useSelector((state) => state.orderList.selectedShipment)
  const selectedOrderItem = useSelector((state) => state.serialNumbers.selectedOrderItem)
  const selectedInventoryItem = useSelector((state) => state.inventory.selectedInventoryItem)
  const [serialNumberBrowserTitle, setSerialNumberBrowserTitle] = useState()
  const isFetchingSerialNumbers = useSelector(
    (state) => state.serialNumbers.isFetchingSerialNumbers,
  )
  const fetchSerialNumbersError = useSelector(
    (state) => state.serialNumbers.fetchSerialNumbersError,
  )
  const isLoading =
    parentFeature === parentFeatureConstants.INVENTORY ? isFetchingSerialNumbers : false
  const inventoryPageTitle = selectedClient?.clientShortName
    ? `${selectedClient?.clientShortName} - ${selectedItemTag?.tag} ${Constants.inventory.SERIAL_NUMBERS}`
    : `${selectedItemTag?.tag} ${Constants.inventory.SERIAL_NUMBERS}`
  const ordersPageTitle = selectedClient?.clientShortName
    ? `${selectedClient?.clientShortName} - ${Constants.orders.NDC_ITEM} ${selectedOrderItem?.itemNumber} ${Constants.orders.SERIAL_NUMBERS}`
    : `${Constants.orders.NDC_ITEM} ${selectedOrderItem?.itemNumber} ${Constants.orders.SERIAL_NUMBERS}`
  const browserTabTitle = selectedClient?.clientShortName
    ? `${selectedClient?.clientShortName} - ${serialNumberBrowserTitle}`
    : serialNumberBrowserTitle
  useBrowserTabTitles(browserTabTitle)

  /* Fetch serial numbers on page load */
  useEffect(() => {
    if (parentFeature === parentFeatureConstants.INVENTORY) {
      dispatch(fetchSerialNumbers())
    }
  }, [dispatch, parentFeature])

  /* Setting Browser Tab */
  useEffect(() => {
    if (parentFeature === parentFeatureConstants.ORDERS && dmsUser === 'Y') {
      setSerialNumberBrowserTitle(
        `${Constants.orders.SERIAL_NUMBERS} - ${Constants.orders.ORDER} ${selectedOrder?.dms_order} - ${Constants.orders.SHIPMENT} ${selectedShipment?.wmsOrderNum}`,
      )
    }
    if (parentFeature === parentFeatureConstants.ORDERS && dmsUser === 'N') {
      setSerialNumberBrowserTitle(
        `${Constants.inventory.SERIAL_NUMBERS} - ${Constants.inventory.SHIPMENT} ${selectedOrder?.wms_order}`,
      )
    }
    if (parentFeature === parentFeatureConstants.INVENTORY) {
      setSerialNumberBrowserTitle(
        `${Constants.itemTagTable.TAG} ${selectedItemTag?.tag} ${Constants.inventory.SERIAL_NUMBERS} - ${Constants.inventory.NDC_ITEM} ${selectedInventoryItem?.itemNumber}`,
      )
    }
  }, [
    dmsUser,
    parentFeature,
    selectedInventoryItem?.itemNumber,
    selectedItemTag?.tag,
    selectedOrder?.dms_order,
    selectedOrder?.wms_order,
    selectedShipment?.wmsOrderNum,
  ])

  /* Display Errors */
  useEffect(() => {
    if (fetchSerialNumbersError) {
      dispatch(
        setSnackbar({
          message: fetchSerialNumbersError?.message,
          severity: 'error',
          action: true,
        }),
      )
    }
  }, [fetchSerialNumbersError, dispatch])

  return (
    <Box sx={{ flexGrow: 1 }}>
      <GenericNav selected={parentFeature} user='authenticated' />
      <Backdrop open={isLoading}>
        <CircularProgress color='inherit' />
      </Backdrop>
      <Container maxWidth='xl'>
        <Grid container spacing={3}>
          <Grid size={{ xs: 8 }} data-testid='pageTitle'>
            {parentFeature === parentFeatureConstants.INVENTORY && (
              <PageTitle gridSize={12} title={inventoryPageTitle} />
            )}
            {parentFeature === parentFeatureConstants.ORDERS && (
              <PageTitle gridSize={12} title={ordersPageTitle} />
            )}
          </Grid>
          <Grid size={{ xs: 12 }}>
            {parentFeature === parentFeatureConstants.ORDERS ? (
              <OrderItemDetailsCard />
            ) : (
              <ItemTagDetailsCard />
            )}
          </Grid>
          <Grid size={{ xs: 12 }}>
            <SerialNumbersTable />
          </Grid>
        </Grid>
      </Container>
      <GenericSnackbar />
    </Box>
  )
}

export default SerialNumbers
